import "./Navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="team-title">
        TEAM 3<span className="highlight">3</span>3
      </div>
    </nav>
  );
};

export default Navbar;
